import { AttributeKindEnum } from "@brewbase/db/types";
import type { BaseTemplateAttribute, Selection } from "./types";
import { ScalarRow } from "./scalar-row";

interface ScalarBlockProps {
  attributes: BaseTemplateAttribute[];
  selection: Selection;
  isLocked: boolean;
  onSelect: (id: number) => void;
  onUpdateName: (id: number, name: string) => void;
  onInsert: (position: number, kind: AttributeKindEnum) => void;
  /** Flat position of the first attribute in this block */
  startPosition: number;
  /** Whether this block has a gap before it */
  hasBlockGap: boolean;
}

export function ScalarBlock({
  attributes,
  selection,
  isLocked,
  onSelect,
  onUpdateName,
  onInsert,
  startPosition,
  hasBlockGap,
}: ScalarBlockProps) {
  return (
    <>
      {attributes.map((attr, i) => (
        <ScalarRow
          key={attr.id}
          attribute={attr}
          isFirst={i === 0}
          isFirstInBlock={i === 0 && hasBlockGap}
          isSelected={
            selection?.type === "attribute" &&
            selection.attributeId === attr.id
          }
          isLocked={isLocked}
          onSelect={onSelect}
          onUpdateName={(name) => onUpdateName(attr.id, name)}
          insertPosition={i > 0 ? startPosition + i : null}
          onInsert={onInsert}
        />
      ))}
    </>
  );
}
